export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const USER_DETAIL_REQUEST = 'USER_DETAIL_REQUEST';
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS';
export const USER_DETAIL_FAILURE = 'USER_DETAIL_FAILURE';

export const SIGNUP_DETAILS = 'SIGNUP_DETAILS';

export const VALIDATE_BVN_REQUEST = 'VALIDATE_BVN_REQUEST';
export const VALIDATE_BVN_SUCCESS = 'VALIDATE_BVN_SUCCESS';
export const VALIDATE_BVN_FAILURE = 'VALIDATE_BVN_FAILURE';

export const LOG_OUT = 'LOG_OUT';
